import HorizontalRule from '../extensions/HorizontalRule/HorizontalRule';
import Link from '../extensions/Link/link';

export const isTableGripSelected = (node) => {
  let container = node;

  while (container && !['TD', 'TH'].includes(container.tagName)) {
    container = container.parentElement;
  }

  const gripColumn = container?.querySelector?.('a.grip-column.selected');
  const gripRow = container?.querySelector?.('a.grip-row.selected');

  if (gripColumn || gripRow) {
    return true;
  }

  return false;
};

export const isCustomNodeSelected = (editor, node) => {
  const customNodes = [HorizontalRule.name, Link.name];

  return customNodes.some((type) => editor.isActive(type)) || isTableGripSelected(node);
};

export default isCustomNodeSelected;
